export default __webpack_public_path__ + "static/media/partners.e96971ef.jpeg";